import estimatesData from './mock/behavioural-data/BABA.USEstimatesFCurveQuaterly'
import bondConvictionData from './mock/behavioural-data/1928.HKBondConviction'
import highConvictionData from './mock/behavioural-data/1928.HKHighConviction'

const behaviourChartConst = [
  {
    title: 'Forward Looking EPS Forecast',
    subTitle: 'Earnings Risk',
    mockData: estimatesData,
    data: [],
    type: 'ProjectionChart',
    yKey: null,
    tooltipInfo: {
      title: 'Forward Looking EPS Forecast',
      subTitle: 'Earnings Risk',
      whatToShow: 'Is there risk to forward earnings?',
      thingsToLookOutFor:
        'EPS is the metric most heavily analysed and forecasted by equity analysts, and gives a valuable insight into future outlook. Below is the forward ‘estimate curve’ of both the broad consensus and those analysts who historically have the best accuracy in predicting earnings. Look for abnormal negative spread between the smart consensus and consensus, and consider it in the context of two things: where in the curve it is (near-term vs longer term) and the historic accuracy of the smart consensus.',
      nextBestAction:
        'If you see a divergence between smart consensus and consensus, consider equity valuations, alongside the implications an earnings shock might have on other financial ratios such as leverage or debt servicing for example.',
    },
  },
  {
    title: `Equity Investor Confidence`,
    subTitle: 'Active Investors',
    mockData: highConvictionData,
    data: [],
    type: 'AreaChart',
    yKey: 'holding_percentage_6m',
    tooltipInfo: {
      title: `Equity Investor Confidence`,
      subTitle: 'Active Investors',
      whatToShow: 'How convicted are the major equity holders of the company?',
      thingsToLookOutFor:
        'The indices below show relative weight of conviction equity holders and major bondholders within the relevant parts of the company’s capital structure. weakening in either of these ratios may indicate a breakdown in confidence among those investors, or leave the company less resilient to negative events in the future.',
      nextBestAction:
        'If you see equity conviction weakening, consider this in context of the company’s capital structure (i.e., how important is equity to the company’s funding mix?). Then consider the broader picture including event, earnings and financial risk as well as valuation and upcoming funding requirements.',
    },
  },
  {
    title: 'Bond Investor Confidence',
    subTitle: 'Largest Holders',
    mockData: bondConvictionData,
    data: [],
    type: 'AreaChart',
    yKey: 'top_25_percentage_6m',
    tooltipInfo: {
      title: 'Bond Investor Confidence',
      subTitle: 'Largest Holders',
      whatToShow: 'How convicted are the major bondholders of the company?',
      thingsToLookOutFor:
        'The indices below show relative weight of conviction equity holders and major bondholders within the relevant parts of the company’s capital structure. weakening in either of these ratios may indicate a breakdown in confidence among those investors, or leave the company less resilient to negative events in the future.',
      nextBestAction:
        'If you see bondholder conviction weakening, consider this in context of the company’s capital structure (i.e., how important is debt to the company’s funding mix?). Consider the broader picture including event, earnings and financial risk and particularly any upcoming funding requirements or potential refinancing / maturity events.',
    },
  },
]

export default behaviourChartConst
